goog.provide('el8.tourguide.Shade');

goog.require('el8.uiwidget.Shade');

el8.tourguide.Shade = el8.uiwidget.Shade;


